import request from "@/utils/request";


export function producttype(query) {
    return request({
        url: '/website/websitehome/producttype/'+query.id,
        method: 'get',
        params: query
    })
}


export function websitescreenssearch(query) {
    return request({
        url: '/website/websitehome/websitescreenssearch',
        method: 'get',
        params: query
    })
}

export function websitescreensbyId(id) {
    return request({
        url: '/website/websitehome/websitescreensbyId/'+id,
        method: 'get',
    })
}